import { render, staticRenderFns } from "./RemessaBoletoRetorno.vue?vue&type=template&id=634237cb&scoped=true"
import script from "./RemessaBoletoRetorno.vue?vue&type=script&lang=js"
export * from "./RemessaBoletoRetorno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634237cb",
  null
  
)

export default component.exports